module.exports = __webpack_public_path__ + "img/270x570.6b56982e.png";